import { useLocation } from 'react-router-dom';
import { userPermissions } from '../../../constants/enums/Permissions';
import { currentUser, isAuthorized, logOut } from '../../../utils/Auth/auth';
import Select from 'react-select';

const { default: MenuItem } = require('./MenuItem/MenuItem');

const Menu = () => {
  // eslint-disable-next-line no-unused-vars
  const { pathname } = useLocation();

  const authorizedTabs = [
    {
      id: 'home',
      link: '/',
      text: 'HOME',
      customClasses: 'mr-8',
    },
    currentUser?.canParTracking && {
      id: 'canParTracking',
      link: '/canParTracking',
      text: 'CANPAR TRACKING',
      customClasses: 'mr-8',
    },
    currentUser?.userAccounts && {
      id: 'users',
      link: '/users',
      text: 'USERS',
      customClasses: 'mr-8',
    },
    currentUser?.administrators && {
      id: 'admins',
      link: '/admins',
      text: 'ADMIN PANEL',
      customClasses: 'mr-8 text-red-700 hover:text-red-800',
    },
    currentUser?.agentList && {
      id: 'agentList',
      link: '/agentList',
      text: 'AGENTS LIST',
      customClasses: 'mr-8',
    },
    (currentUser?.parcelRates === userPermissions.read ||
      currentUser?.parcelRates === userPermissions.write) && {
      id: 'parcelRates',
      link: '/parcelRates',
      text: 'PARCEL RATES',
      customClasses: 'mr-8',
    },
    currentUser?.odooSync && {
      id: 'odooPortalSync',
      link: '/odooPortalSync',
      text: 'ODOO-PORTAL SYNC',
      customClasses: 'mr-8',
    },
    (currentUser?.shipments === userPermissions.read ||
      currentUser?.shipments === userPermissions.write) && {
      id: 'shipmentsinfo',
      link: '/shipmentsinfo',
      text: currentUser?.moneyTransfers
        ? 'SHIPMENTS / MONEY TRANSFERS'
        : 'SHIPMENTS',
      customClasses: 'mr-8',
    },
    currentUser?.containerBranchChange && {
      id: 'changeBranchForContainer',
      link: '/changeContainerBranch',
      text: 'CHANGE CONTAINER BRANCH',
      customClasses: 'mr-8',
    },
    currentUser?.reports && {
      id: 'reports',
      link: '/reports',
      text: 'REPORTS',
      customClasses: 'mr-8',
    },
    currentUser?.refund && {
      id: 'refund',
      link: '/refund',
      text: 'REFUND',
      customClasses: 'mr-8',
    },
    {
      id: 'logOut',
      text: 'LOG OUT',
      action: logOut,
    },
  ];

  const previewTabs = [
    {
      id: 'home',
      link: '/',
      text: 'HOME',
      customClasses: 'mr-8',
    },
    {
      id: 'signIn',
      link: '/SignIn',
      text: 'SIGN IN',
    },
  ];

  const shownTabs = isAuthorized ? authorizedTabs : previewTabs;

  const handleChange = (selectedOption) => {
    const selectedTab = shownTabs.find(
      (tab) => tab.id === selectedOption.value,
    );
    if (selectedTab?.link) {
      window.location.href = selectedTab.link;
    } else if (selectedTab?.action) {
      selectedTab.action();
    }
  };

  const selectOptions = shownTabs.map((item) => ({
    value: item.id,
    label: item.text,
  }));

  const currentTab = selectOptions.find(
    (item) => item.value === shownTabs.find((x) => x.link === pathname)?.id,
  );
  return (
    <div className="ml-auto">
      <div className="hidden xl:inline-block">
        {shownTabs.map((item, index) => (
          <MenuItem
            decorationClasses={item.id === 'admins' ? 'bg-red-700' : null}
            action={item.action}
            text={item.text}
            key={index}
            link={item.link}
            customClasses={item.customClasses}
          />
        ))}
      </div>

      <div className="relative inline-block xl:hidden">
        <Select
          isSearchable={false}
          styles={{
            control: (provided) => ({
              ...provided,
              border: 'none',
              boxShadow: 'none',
              padding: '0',
              backgroundColor: 'none',
              textAlign: 'right',
            }),
            indicatorSeparator: () => ({
              display: 'none',
            }),
            menu: (provided) => ({
              ...provided,
              minWidth: '300px',
              left: '-90px',
              top: '30px',
            }),
            menuList: (provided) => ({
              ...provided,
              width: 'auto',
              minWidth: '300px',
              // minHeight: !!currentUser && '340px',
              maxHeight: 'none',
            }),
            singleValue: (provided) => ({
              ...provided,
              color: '#09008E',
            }),
          }}
          value={currentTab}
          options={selectOptions.filter((i) => !!i?.value)}
          onChange={handleChange}
          className="min-w-[200px] w-full text-blue-800 text-left"
        />
      </div>
    </div>
  );
};

export default Menu;
